import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import "./css/header.css";
import MenuUsuario from "./MenuUsuario";
import MenuProcedimento from "./MenuProcedimento";
import MenuPaciente from "./MenuPaciente";
import MenuProducao from "./MenuProducao";
import MenuEmpresa from "./MenuEmpresa";
import MenuRelatorio from "./MenuRelatorio";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import MenuFinanceiro from "./MenuFinanceiro";

class Header extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.state = { showSidebar: false };
  }

  logout() {
    API.get("/acesso/logout")
      .then((json) => {
        localStorage.removeItem("accessToken");
        this.props.history.push("/login");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    let menuStyle = {
      paddingTop: "5px",
      paddingBottom: "5px",
      border: "1px solid #999",
    };

    let sidebarStyle = {
      display:
        this.state.showSidebar || window.innerWidth >= 991 ? "block" : "none",
    };

    return (
      <nav className="navbar horizontal-layout col-lg-12 col-12 p-0">
        <div className="nav-top flex-grow-1">
          <div className="container d-flex flex-row h-100">
            <div className="text-center navbar-brand-wrapper d-flex align-items-center">
              <a className="navbar-brand brand-logo" href="/inicio">
                <img src="/images/header-logo.png" alt="logo" />
              </a>
              <a className="navbar-brand brand-logo-mini" href="/inicio">
                <img src="/images/header-logo-mini.png" alt="logo" />
              </a>
            </div>
            <div className="navbar-menu-wrapper d-flex align-items-stretch justify-content-between flex-grow-1">
              <ul className="navbar-nav navbar-nav-right mr-0 ml-auto">
                <li className="nav-item nav-profile dropdown">
                  <span
                    className="nav-link dropdown-toggle link"
                    data-toggle="dropdown"
                    id="profileDropdown"
                  >
                    <div className="profile-picture">
                      {this.props.usuario.emulado && (
                        <i className="fa fa-vcard" />
                      )}
                      {!this.props.usuario.emulado &&
                        this.props.usuario.nome[0]}
                    </div>
                    <span className="nav-profile-name">
                      {this.props.usuario.emulado &&
                        this.props.usuario.nome + " (emulado)"}
                      {!this.props.usuario.emulado && this.props.usuario.nome}
                    </span>
                  </span>
                  <div
                    className="dropdown-menu navbar-dropdown"
                    style={menuStyle}
                  >
                    {this.props.usuario.emulado && (
                      <span
                        onClick={() => {
                          window.location.href = "/usuario/consulta";
                        }}
                        className="dropdown-item"
                      >
                        <i className="fa fa-vcard-o" />
                        &nbsp; Remover emulação
                      </span>
                    )}
                    <span onClick={this.logout} className="dropdown-item">
                      <i className="fa fa-sign-out" />
                      &nbsp; Logout
                    </span>
                  </div>
                </li>
              </ul>
              <button
                className="navbar-toggler align-self-center"
                type="button"
                data-toggle="minimize"
                onClick={() => {
                  this.setState({ showSidebar: !this.state.showSidebar });
                }}
              >
                <span className="icon-menu text-light" />
              </button>
            </div>
          </div>
        </div>
        <div style={sidebarStyle} className="nav-bottom">
          <div className="container">
            <ul className="nav page-navigation">
              {this.props.usuario.perfil <= 1 && (
                <li className="nav-item">
                  <Link to="/inicio" className="nav-link">
                    <i className="link-icon icon-home" />
                    <span className="menu-title">Início</span>
                  </Link>
                </li>
              )}
              {this.props.usuario.perfil === 0 && <MenuEmpresa />}
              {this.props.usuario.perfil <= 1 && <MenuUsuario />}
              <MenuPaciente />
              {this.props.usuario.perfil <= 1 && <MenuProcedimento />}
              <MenuProducao />
              {this.props.usuario.perfil <= 1 && <MenuFinanceiro />}
              <MenuRelatorio />
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(Header);
